import NodeUsage from "../components/NodeDashboard/NodeUsage";
import SideNavBar from "../components/NavBar/SideBar"
import Navbar from '../components/NavBar/Navbar';

const NodeUsagePage = () =>{
    return (
        <div style={{ display: 'flex', width:'100% !important', position: 'fixed'}}>
            <SideNavBar />
            <div style={{  width: '50% !important' }}>
                <div className="navbar-content">
                    <Navbar title="Node Monitor"/>
                </div> 
                <NodeUsage/>
            </div>
        </div>
    );
}

export default NodeUsagePage;